import { AxiosError } from "axios";
import {
  ApplicationStatus,
  GetApplicationResponse,
  SubmitApplicationResponse,
} from "components/IncreaseCreditLimit/types";
import { getHref, postHref } from "library/api";
import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { REFETCH_INTERVAL } from "../constants/constants";
import {
  NzParseSubmitApplicationResponseReturnType,
  NzSubmitApplicationRequest,
  State,
} from "../types";
import {
  getNzApplicationPayload,
  nzParseSubmitApplicationResponse,
} from "../utils";

export const useSubmit = (state: State) => {
  const { account } = state;

  const submitUrl = account?.links.find(
    (link) => link.rel === "credit_limit_increase",
  )?.href;

  return useMutation<
    NzParseSubmitApplicationResponseReturnType,
    AxiosError,
    { agreeToConsent: boolean }
  >(async (values) => {
    if (!submitUrl) {
      console.error("Submit URL is missing is the GET application response.");
      return null;
    }
    const response = await postHref<
      SubmitApplicationResponse,
      NzSubmitApplicationRequest
    >(submitUrl, getNzApplicationPayload(state, values));
    // TODO: RL-1021 parse submit application response
    const responseData = nzParseSubmitApplicationResponse(response.data);
    if (
      responseData === null ||
      responseData.application.status ===
        ApplicationStatus.INTERNAL_SERVICE_ERROR
    ) {
      // Here follow AU
      // TODO: RL-1061 consider showing system error page
      throw new window.Error(
        "Invalid submit CLI application response received",
      );
    }
    return responseData;
  });
};

export const useGetSubmissionResult = (
  getSubmissionResultUrl: string,
  enabled: boolean,
) => {
  const [applicationResponse, setApplicationResponse] = useState<
    GetApplicationResponse | null | undefined
  >(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getSubmissionResult = useQuery<GetApplicationResponse, AxiosError>(
    ["cli-submission-result", getSubmissionResultUrl],
    async () => {
      setIsLoading(true);
      const response = await getHref<GetApplicationResponse>(
        getSubmissionResultUrl,
      );
      return response.data;
    },
    {
      enabled,
      initialData: undefined,
      onSuccess(response) {
        if (!response) {
          getSubmissionResult.remove();
          setApplicationResponse(response);
        }
        const {
          application: { status },
        } = response;
        switch (status) {
          case ApplicationStatus.CLI_IN_PROGRESS:
            // Wait some seconds and get result again
            break;
          default:
            setIsLoading(false);
            getSubmissionResult.remove();
            setApplicationResponse(response);
        }
      },
      refetchInterval: REFETCH_INTERVAL,
    },
  );
  return {
    isLoading,
    isError: getSubmissionResult.isError,
    applicationResponse,
  };
};
